import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormEditMode } from '../../dynamic-form/interfaces/dynamic-field.interface';
import { IconModule } from '../../../../icon/icon.module';

@Component({
    selector: 'lc-form-edit-mode-header',
    standalone: true,
    imports: [CommonModule, IconModule],
    template: `
        @if (editMode?.active) {
            <div class="edit-mode-header">
                <div class="flex items-center space-x-3">
                    <div class="flex-shrink-0">
                        <div class="identifier-badge">
                            <span class="identifier-text">
                                {{ editMode?.identifier || '#' }}
                            </span>
                        </div>
                    </div>
                    <div class="flex-1">
                        <h3 class="form-title">
                            {{ editMode?.formTitle }}
                        </h3>
                        <p class="form-subtitle">
                            {{ editMode?.identifierLabel }} #{{ editMode?.identifier || 'N/A' }}
                            @if (editMode?.date) {
                                •
                                {{ editMode?.date ? (editMode?.date | date: 'dd/MM/yyyy') : 'Data não informada' }}
                            }
                        </p>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="action-badge">
                            @if (editMode?.action === 'edit') {
                                <icon-pencil class="mr-1" />
                            } @else {
                                <icon-eye class="mr-1" />
                            }
                        </span>
                    </div>
                </div>
            </div>
        }
    `,
    styles: [
        `
            .edit-mode-header {
                @apply mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50
                   dark:from-gray-800 dark:to-gray-700 rounded-lg border
                   border-blue-200 dark:border-gray-600 shadow-sm;
            }

            .identifier-badge {
                @apply px-2 min-w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-full
                   flex items-center justify-center;
            }

            .identifier-text {
                @apply text-blue-600 dark:text-blue-400 text-lg font-semibold;
            }

            .form-title {
                @apply text-sm font-semibold text-gray-900 dark:text-white;
            }

            .form-subtitle {
                @apply text-xs text-gray-600 dark:text-gray-300;
            }

            .action-badge {
                @apply inline-flex items-center px-3 py-1 rounded-full text-xs font-medium
                   bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200;
            }
        `,
    ],
})
export class FormEditModeHeaderComponent {
    @Input() editMode?: FormEditMode;
}
